import React from 'react';
import { useHistory } from 'react-router-dom';
import { FilePenLine } from 'lucide-react';

import { Bloc } from '@mairistem/administres-utils';
import { Button } from '@mairistem/composants';

import { baseUrlApp } from '@/routes/base';

interface BlocCreationProps {
  style?: React.CSSProperties;
}

const BlocCreation = (props: BlocCreationProps) => {
  const { style } = props;

  const history = useHistory();

  const handleClick = React.useCallback(() => {
    history.push(`${baseUrlApp}assistant`);
  }, [history]);

  return (
    <Bloc
      icon={<FilePenLine />}
      header="Saisir une nouvelle déclaration"
      style={style}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Button
          primary
          icon="plus"
          color="blue"
          size="big"
          data-testid="bloc-creation-bouton-saisir-declaration"
          content="Saisir une déclaration"
          onClick={handleClick}
          className="custom-blue-button"
          style={{
            width: 'auto',
            borderRadius: '8px',
          }}
        />
      </div>
    </Bloc>
  );
};

export default BlocCreation;
